import { config } from './config'
import { ApiGetResponse } from './helpers'
import { httpClient } from './http-client'

export function getLatestFeeling() {
  return httpClient.get<ApiGetResponse<'/feelings/latest'>>(
    `${config.apiUrl}/feelings/latest`
  )
}
